<!--
  Asks before releasing a lead bot: the lead gets their invite right away, which
  can't be undone. Used by the review banner and the list of demo requests.
-->
<script setup lang="ts">
import { computed } from 'vue';
import { Send } from '@lucide/vue';
import type { DemoLeadReview } from '@/services/demo';
import HubDialog from '@/components/hub/HubDialog.vue';

const props = defineProps<{
  modelValue: boolean;
  lead: DemoLeadReview;
  /** While the release is running */
  loading?: boolean;
}>();

defineEmits<{
  'update:modelValue': [open: boolean];
  confirm: [];
}>();

const name = computed(() => [props.lead.contact.firstName, props.lead.contact.lastName].filter(Boolean).join(' '));
</script>

<template>
  <HubDialog
    :model-value="modelValue"
    title="AI Agent jetzt freigeben?"
    modal
    :loading="loading"
    primary-label="Jetzt freigeben"
    :primary-icon="Send"
    manual-primary
    @update:model-value="$emit('update:modelValue', $event)"
    @on-primary="$emit('confirm')"
  >
    <p class="text-body-1">
      {{ name || 'Der Lead' }} bekommt sofort die Einladung zu diesem AI Agent, per Mail an {{ lead.contact.email }}.
      Das lässt sich nicht rückgängig machen.
    </p>
  </HubDialog>
</template>
